import { useRouter } from 'next/navigation';
import React, { useContext, useEffect } from 'react';

import { AppContext } from '../../App';
import { KDSPermission, RoutePaths } from '../../libs';
import { usesKeycloak } from '../../libs/keycloakSession';

interface ProtectedRouteProps {
  permission: KDSPermission;
  // The route is for Calo Hub sessions only; a Cognito session is sent home as if it lacked the permission.
  hubOnly?: boolean;
  children: React.ReactNode;
}

const ProtectedRoute = ({ permission, hubOnly = false, children }: ProtectedRouteProps) => {
  const { user } = useContext(AppContext);
  const router = useRouter();
  const allowed = user.permissions?.includes(permission) === true && (!hubOnly || usesKeycloak());

  useEffect(() => {
    if (!allowed) {
      router.replace(RoutePaths.home);
    }
  }, [allowed, router]);

  return allowed ? children : null;
};

export default ProtectedRoute;
